import React, { Component } from 'react'
import rooms from "../../../res/roomnames"
import theme from '../../theme'


// material ui
import FormControl from '@mui/material/FormControl'

import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem'
import FormHelperText from '@mui/material/FormHelperText'
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';

// application assets
import ManuelSrc from '../../assets/wohnzimmerSvg'
import ManuelItem from '../../assets/manuellSVG'
import SleepTimeIcon from '../../assets/sleepTimeSVG'
import TimeProgramSrc from '../../assets/timeProgrammSVG'
import ShockVentilationSrc from '../../assets/rotatingFanSVG'
import HumiditySrc from '../../assets/dropSVG'
import CO2Src from '../../assets/leafSVG'

// application components
import Ax from '../../hoc/Ax/Ax'
import Card from '../../components/Card/Card'
import CardTextElement from '../../components/Card/CardText'
import Mode from '../../components/Mode/Mode'
import ModeItem from '../../components/Mode/ModeItem/ModeItem'
import Slider from '../../components/Slider/Slider'
import Information from '../../components/Information/Information'
import SwitchTime from '../../components/SwitchTime/SwitchTime'
import SwitchTimeItem from '../../components/SwitchTime/SwitchTimeItem/SwitchTimeItem'
import Sidebar, { SidebarItem } from '../../components/Sidebar'
//import Sidebar, { SidebarContent, SidebarHeader } from '../Devices/Sidebar/Sidebar';
import TimePicker from '../../components/TimePicker/TimePicker'
import {apiClient} from "../../../services/api";
import Button from '@mui/material/Button';
import Input from '@mui/material/Input'

import log from 'loglevel'

import { t } from 'i18next'
import i18next from 'i18next'
import { Trans } from 'react-i18next'
import {getEnglishRoomNameByGerman} from '../../../utils/elsc_utils'

const styles = {
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        display: 'flex',
        height: '100%',
    },
    cardWrapper: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        overflowX:'hidden',
        overflowY:"auto",
        height:'100%',
        marginBottom:20,
        paddingBottom:20,
        //flexWrap: 'wrap',
        //maxWidth: '80%',
        [theme.breakpoints.down('xs')]: {
            alignItems: 'center',
            flexDirection: 'column',
            height:'100%',
            overflowX:'hidden',
            overflowY:"auto",
            //marginBottom:20,
            //paddingBottom:20,

        },
        [theme.breakpoints.down('sm')]: {
            alignItems: 'center',
            flexDirection: 'column',
            height:'100%',
            overflowX:'hidden',
            overflowY:"auto",
            //marginBottom:20,
            //paddingBottom:20,

        }
    },
    cardsTitle: {
        //position: 'absolute',
        marginTop: 20,
        marginBottom: 10,
        padding: '0 10px 10px 0',
        [theme.breakpoints.down('xs')]: {
            marginLeft: '7px',
        },
    },
    cards: {
        //position: 'absolute',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignContent: 'flex-start',
        paddingTop: theme.spacing.unit * 8,
        marginBottom:20,
        paddingBottom:20,

        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom:theme.dimensions.cardGap,
            paddingBottom:20,
        },
    },
    // view specific
    overLimit: {
        color: '#8AC43F',
        borderBottom: '1px solid #2D727F',
    },
    underLimit: {
        color: '#990000',
        textDecoration: 'line-through',
    },
    textFieldFormLabel: {
        '&$textFieldFocused': {
            color: theme.palette.primary.dark,
        },
    },
    textFieldFocused: {},
    textFieldUnerline: {
        '&:after': {
            borderBottomColor: theme.palette.primary.dark,
        },
    },
    select: {
        '&:before': {
        borderColor: theme.palette.primary.main,
         },
        '&:after': {
         borderColor: theme.palette.primary.dark,
        }
    },
    icon: {
        fill: theme.palette.primary.dark,
    },
    sendButton:{
        color: theme.palette.primary.dark,
        borderColor: theme.palette.primary.dark,
        marginTop: 20,
    }
}


class Scopes extends Component {

    constructor(props) {
        super(props);

        this.state = {
            activeCard: false,
            sidebarOpen: false,
            sidebarChanged: false,
            selectedValue: '',
            openModeSettings: false,
            scopes: props.scopes,
        }

    }

    componentDidMount () {
        log.debug(this.state)
        log.debug(this.props)
    }

    componentWillReceiveProps(nextProps) {
        var switchTimerChanged = false;
        if (this.state.scopes != null && typeof this.state.scopes.forEach !== "undefined") {
            this.state.scopes.forEach( scope => {
                if (scope.hasOwnProperty('unsavedTimerChanges')) {
                    if (scope.unsavedTimerChanges) {
                        switchTimerChanged = true;
                    }
                }
            });
        }

        log.debug("received props", nextProps);
        if (!switchTimerChanged) {
            if (nextProps.scopes != null) {
                this.setState({scopes: nextProps.scopes});
            }
        }

    }

    /**
     * set active card
     * @param activeCard
     */
    changeCard = activeCard => {

        this.setState({
            sidebarOpen: true,
            activeCard,
            openModeSettings: false,
        })
        this.props.onZoneSelected(this.state.scopes[activeCard]);
    }

    /**
     * select @ sidebar
     * @param selectedValue
     */
    handleSelectChange = selectedValue => {
        var _state = this.state
        _state.scopes[this.state.activeCard].label = selectedValue
        this.setState({_state})
        apiClient.post('control/label', {deviceid: this.props.currentDeviceId, zone: this.state.scopes[this.state.activeCard].index, label: selectedValue})
            .then((response) => {
                if (response.ok === true) {
                    return response.json();
                }
            })
            .catch((err) => {
                log.error("ERROR ON Label CHANGE", err);
            })
    }

    /**
     * closing sidebar
     */
    handleSidebarClose = () => {
        this.setState({
            activeCard: false,
            sidebarOpen: !this.state.sidebarOpen,
            sidebarChanged: false,
            openModeSettings: false,
        })
    }

    /**
     * mode selection
     */
    handleModeChange = mode => {
        log.debug("handleModeChange", mode);
        var _state = this.state
        _state.scopes[this.state.activeCard].modeId = mode
        // this.state.scopes[this.state.activeCard].modeId = mode;
        switch(mode) {
            case 1:
                _state.scopes[this.state.activeCard].value = 3;
            break;
            default:
                break
        }

        this.setState({_state})
        this.props.onModeChanged(mode);
    }

    /**
     * set slider value to scope
     */
    handleSliderChange = value => {
        var _state = this.state
        _state.scopes[this.state.activeCard].value = value
        this.setState({_state})
        this.props.onVentilationLevelChanged(value)
    }

    /**
     * manipulate timer slider value from active element
     * @param timerIndex
     * @param value
     */
    handleSliderChangeTimers = (timerIndex, value) => {
        const timers = { ...this.state.scopes[this.state.activeCard].timers }
        Object.keys(timers).forEach(tmpKey => {
            if (tmpKey === timerIndex) {
                timers[tmpKey].ventilationLevel = value
            }
        })

        this.setState({
            scopes: {
                ...this.state.scopes,
                [this.state.activeCard]: {
                    ...this.state.scopes[[this.state.activeCard]],
                    timers,
                },
            },
        })


    }

    /**
     * if user changes sidebar content and save
     */
    handleSidebarChange = () => {
        this.setState({
            sidebarChanged: false,
            openModeSettings: false,
        })
    };

    /**
     * set
     * @param checked
     * @param timerKey
     */
    handleSwitchTimeItemChange = (key, value, timerKey) => {
        const { scopes, activeCard } = this.state;
        const item = scopes[activeCard];

        if(!item.unsavedTimerChanges) item.unsavedTimerChanges = {};

        if(!item.unsavedTimerChanges[timerKey]) item.unsavedTimerChanges[timerKey] = {...item.timers[timerKey]};
        item.unsavedTimerChanges[timerKey][key] = value;

        this.setState({scopes});
    };

    /**
     * set time to active scope timer
     * @param time
     */
    timePickerChange = time => {
        const timers = { ...this.state.scopes[this.state.activeCard].timers };
        Object.keys(timers).forEach(tmpKey => {
            if (tmpKey === this.state.openModeSettings) {
                timers[tmpKey].time = time
                log.debug('key ' + tmpKey + ' time: ' + time)
            }
        })

        this.setState({
            scopes: {
                ...this.state.scopes,
                [this.state.activeCard]: {
                    ...this.state.scopes[[this.state.activeCard]],
                    timers,
                },
            },
        })
    }

    /**
     * get mode component depends on selected mode or timers from scope
     * @param mode
     * @param scope
     * @param value
     * @returns {boolean}
     */
    getCurrentModeComponent = (mode, scope, value) => {
        // log.debug("getCurrentModeComponent", mode, scope, value)

        if(!mode) return null;
        var modeId = parseInt(mode.modeId, 10);


        // log.debug(modeId)
        let modeComponent = false
        const size = (!scope) ? 80 : 24
        const color = (!scope) ? '#fff' : this.getCurrentModeColorByMode(modeId)

        switch (modeId) {
            case 1:
                if (!scope) {
                    modeComponent = <ManuelSrc level={6} active={parseInt(mode.value, 10)}/>
                } else {
                    modeComponent = <ManuelSrc color={color} level={6} active={parseInt(mode.value, 10)} />
                }
                break
            case 2:
                modeComponent = <ShockVentilationSrc color={color} width={size} height={size}/>
                break
            case 3:
                modeComponent = <SleepTimeIcon color={color} width={size} height={size}/>
                break
            case 4:
                modeComponent = <HumiditySrc color={color} width={size} height={size}/>
                break
            case 5:
                modeComponent = <TimeProgramSrc color={color} width={size} height={size}/>
                break
            case 6:
                modeComponent = <CO2Src color={color} width={size} height={size}/>
                break
            default:
                modeComponent = <ManuelSrc level={6} active={parseInt(mode.value, 10)}/>
                break
        }

        return modeComponent
    }

    /**
     * set flag for editing active scope timer
     * @param timerKey
     */
    handleModeConfigChange = timerKey => {
        this.setState({
            openModeSettings: timerKey,
        })
    }

    /**
     * get card text depends on selected mode
     * @param scopeKey
     * @returns {*}
     */
    getCurrentCardTxtByScope = scope => {
        let cardTxt = false
        switch (parseInt(scope.modeId, 10)) {
            case 1:
                cardTxt = <CardTextElement label={[t('Scopes.cardtext_label_manual')]}
                                           content={[t('Scopes.cardtext_content_manual') + ` ${ scope.value }`]}/>
                break
            case 2:
                cardTxt = <CardTextElement label={[t('Scopes.cardtext_label_boost') ]}
                                           content={[t('Scopes.cardtext_content_boost')]}/>
                break
            case 3:
                cardTxt = <CardTextElement label={[t('Scopes.cardtext_label_sleep')]}
                                           //content={[`Dauer: ${ scope.value } min`]}/>
                                           content={[t('Scopes.cardtext_content_sleep')]}/>
                break
            case 4:
                cardTxt = <CardTextElement label={[t('Scopes.cardtext_label_humi')]}
                                           content={[t('Scopes.cardtext_content_humi') + `: ${ scope.feuchte }%`]}/>
                break
            case 5:
                cardTxt = <Ax>
                    <CardTextElement label={[t('Scopes.cardtext_label_time')]}/>
                    {/*<CardTextElement label={['Modus']} content={false ? ["123"] : null }/>*/}
                </Ax>
                break
            case 6:
                cardTxt = <CardTextElement label={[t('Scopes.cardtext_label_co2')]}
                                           content={[t('Scopes.cardtext_content_co2') + `: ${ scope.co2 } ppm`]}/>
                break
            default:
                cardTxt = ''
                break
        }

        return cardTxt
    }

    /**
     * set timer mode for active element
     * @param mode
     */
    handleTimerChange = mode => {
        const timers = { ...this.state.scopes[this.state.activeCard].timers }
        Object.keys(timers).forEach(tmpKey => {
            if (tmpKey === this.state.openModeSettings) {
                timers[tmpKey].selectedMode = mode
            }
        })

        this.setState({
            scopes: {
                ...this.state.scopes,
                [this.state.activeCard]: {
                    ...this.state.scopes[[this.state.activeCard]],
                    timers,
                },
            },
        })
    }

    /**
     * return color string which depends on mode
     * @param mode
     * @returns {boolean}
     */
    getCurrentModeColorByMode = mode => {
        let modeColor = false
        switch (mode) {
            case 1:
                modeColor = theme.palette.card.orange
                break
            case 2 :
                modeColor = theme.palette.card.red
                break
            case 3  :
            case 4  :
                modeColor = theme.palette.card.blue
                break
            case 5  :
                modeColor = theme.palette.card.purple
                break
            case 6  :
                modeColor = theme.palette.card.green
                break
            default:
                modeColor = theme.palette.card.orange
                break
        }
        return modeColor
    }

    /**
     * setting timer flag to false
     */
    closeTimerSettings = () => {
        this.setState({
            openModeSettings: false,
        })
    }

    /**
     * getting mode title
     * @returns {string}
     */
    getModeTitle = mode => {
        let title = false
        switch (mode) {
            case 1:
                title = t('Scopes.title_mode_manual')
                break
            case 2:
                title = t('Scopes.title_mode_boost')
                break
            case 3:
                title = t('Scopes.title_mode_sleep')
                break
            case 4:
                title = t('Scopes.title_mode_humi')
                break
            case 5:
                title = t('Scopes.title_mode_time')
                break
            case 6:
                title = t('Scopes.title_mode_co2')
                break
            default:
                title=''
                break
        }
        return title
    }

    compare = (a, b) => {
        if (a.time < b.time) return -1
        if (a.time > b.time) return 1
        return 0
    }

    /**
     * get all switchTime item
     * @returns {any[]}
     */
    getSwitchTimeElements = () => Object.keys(this.state.scopes[this.state.activeCard].timers).map((timerKey, key) => {
        const { scopes, activeCard } = this.state;

        const activeItem = scopes[activeCard];

        const item = (activeItem.unsavedTimerChanges && activeItem.unsavedTimerChanges[timerKey])
            ? activeItem.unsavedTimerChanges[timerKey]
            : scopes[activeCard].timers[timerKey];

        return (
            <SwitchTimeItem
                key={key}
                value={timerKey}
                item={item}
                name={this.getModeTitle(item.selectedMode)}
                icon={this.getCurrentModeComponent(item.selectedMode, true, item.ventilationLevel)}
                handleCheckedChange={checked => this.handleSwitchTimeItemChange('active', checked, timerKey)}
                handleDataChange={data => this.handleSwitchTimeItemChange('data', data, timerKey)}
                handleModeChange={modeId => this.handleSwitchTimeItemChange('selectedMode', modeId, timerKey)}
                handleTimeChange={time => this.handleSwitchTimeItemChange('time', time, timerKey)}
                openSettings={() => this.handleModeConfigChange(timerKey)}
            />
        )
    });

    getSwitchTimeSave = () => {
        const { classes } = this.props;

        return (
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <Button variant="outlined"
                        style={styles.sendButton}
                        onClick={this.resetSwitchTimeChanges}
                        disabled={false}
                        // color="primary"
                        >Zurücksetzen</Button>
                <Button variant="outlined"
                        style={styles.sendButton}
                        onClick={this.saveSwitchTimeChanges}
                        disabled={false}
                        // color="primary"
                        >Änderungen speichern</Button>
            </div>
        )
    };

    resetSwitchTimeChanges = () => {
        const { scopes } = this.state;

        scopes.forEach( scope => {
            if (scope.hasOwnProperty('unsavedTimerChanges')) {
                delete scope.unsavedTimerChanges;
            }
        });
        this.setState({scopes});
    };

    saveSwitchTimeChanges = () => {
        const { scopes, activeCard } = this.state;
        const activeItem = scopes[activeCard];
        log.debug("saveSwitchTimeChanges", activeItem);

        const unsavedChanges = activeItem.unsavedTimerChanges;
        const changes = activeItem.timers.map( (timer, index) => {
            return unsavedChanges[index] ? unsavedChanges[index] : timer
        });

        log.debug('UNSAVED ', changes, this.state.scopes[this.state.activeCard].deviceid)
        // Reset unsaved states
        scopes[activeCard].timers = changes;
        activeItem.unsavedTimerChanges = false;
        this.setState({scopes: scopes});

        //TODO save changes to backend
        apiClient.post('control/timeprogram', {deviceid: this.props.currentDeviceId, zone: activeItem.index, timers: changes})
            .then((response) => {
                if (response.ok === true) {
                    return response.json();
                }
            })
            .catch((err) => {
                log.error("ERROR ON TIME PROGRAMM CHANGE", err);
            })
        //TODO reset unsavedTimerChanges when save was successful
    };

    /**
     * get all card elements with data
     * @returns {any[]}
     */

    getCardContent = () => {
        const langkey = i18next.language
        var views = [];
        if(this.state.scopes) {
            for(var i =0 ; i < this.state.scopes.length; i++) {
                const scope = this.state.scopes[i];
                if(scope.modeId !== null){

                    if(langkey === "en"){

                        const cardHeadLabel  =getEnglishRoomNameByGerman(scope.label)
                        views.push(

                            <Card
                                key={i+"scope"}
                                label={cardHeadLabel}
                                id={i}
                                scope={scope}
                                icon={this.getCurrentModeComponent(scope, false)}
                                handleCardState={(id) => this.changeCard(id)}
                                active={!(this.state.activeCard === i || !this.state.sidebarOpen)}
                                color={this.getCurrentModeColorByMode(parseInt(scope.modeId, 10))}
                            >
                                {this.getCurrentCardTxtByScope(scope)}
                            </Card>
                        )
                    } else {
                        views.push(

                            <Card
                                key={i+"scope"}
                                label={scope.label}
                                id={i}
                                scope={scope}
                                icon={this.getCurrentModeComponent(scope, false)}
                                handleCardState={(id) => this.changeCard(id)}
                                active={!(this.state.activeCard === i || !this.state.sidebarOpen)}
                                color={this.getCurrentModeColorByMode(parseInt(scope.modeId, 10))}
                            >
                                {this.getCurrentCardTxtByScope(scope)}
                            </Card>
                        )
                    }

                }
            }
        } else {
            views.push(
                <h3>Bereiche nicht eingerichtet.</h3>
            )
        }

        return views;
    }
    // getCardContent = () => Object.keys(this.state.scopes).map(scopeKey => (
    //     <Card
    //         key={scopeKey}
    //         label={this.state.scopes[scopeKey].label}
    //         icon={this.getCurrentModeComponent(scopeKey, false)}
    //         handleCardState={() => this.changeCard(scopeKey)}
    //         active={!(this.state.activeCard === scopeKey || !this.state.sidebarOpen)}
    //         color={this.getCurrentModeColorByMode(this.state.scopes[scopeKey].mode)}
    //     >
    //         {this.getCurrentCardTxtByScope(scopeKey)}
    //     </Card>
    // ))

    renderRoomSelectItems() {
        var selectViews = [];
        const langkey = i18next.language
        // console.log(langkey)
        for(var i = 0; i < rooms.length; i++) {
            const room = rooms[i];
            if(langkey === "en"){
                selectViews.push(
                    <MenuItem value={room.de} key={"menu_item_"+i}>{room.en}</MenuItem>
                )
            } else {
                selectViews.push(
                    <MenuItem value={room.de} key={"menu_item_"+i}>{room.de}</MenuItem>
                )
            }

        }

        return selectViews;
    }

    getScope(activeCard, value) {
        try {

            var a =  this.state.scopes[activeCard][value];

            if (typeof a !== "undefined") {
                return a;
            }
            return null;
        }
        catch(e) {
            console.error(e);
        }
    }

    getSlumberTime = () => {
        log.debug(this.props)
        // return 0
        return this.props.settings.id_56
    }




    render () {
        const { classes } = this.props;
        const { scopes, activeCard } = this.state;

         log.debug('Scopes props ', this.props)

    



        return (
            <div style={styles.root}>
            {/* <RemoveScrollBar/> */}
                <div style={styles.cardWrapper}>
                {/* <div style={{display:'flex', flexDirection:"column"}}> */}
                    <div style={styles.cardsTitle}>
                        <Typography variant="h5">{(this.props.title != null) ? this.props.title : ""}</Typography>
                    </div>

                    <Box style={styles.cards} rowGap={theme.dimensions.cardGap/7} columnGap={theme.dimensions.cardGap/7}>
                        {this.getCardContent()}
                    </Box>
                </div>

               <Sidebar title={(!this.state.openModeSettings) ? t('Scopes.title_sidebar_customzie_area'): t('Scopes.title_sidebar_customzie_time')}
                         open={this.state.sidebarOpen}
                         changed={this.state.sidebarChanged}
                         action={(this.state.openModeSettings) ? 'timerSettings' : false}
                         closed={() => {
                             (this.state.openModeSettings) ? this.closeTimerSettings() : this.handleSidebarClose()
                         }
                         }
                         handleSidebarChange={() => this.handleSidebarChange()}
                >
                    { (typeof activeCard === "number")
                    && (
                        <div>
                            {(!this.state.openModeSettings)
                            && (
                                <SidebarItem divider>
                                    <FormControl fullWidth>
                                        <Select
                                            variant="standard"
                                            sx={{
                                                "&:before": {
                                                  borderColor: theme.palette.primary.dark,
                                                },
                                                "&:after": {
                                                  borderColor: theme.palette.primary.dark,
                                                },
                                                color: "#262626",
                                                ".MuiSvgIcon-root ": {
                                                  fill: theme.palette.primary.dark,
                                                }
                                              }}

                                            /* input={
                                                <Input
                                                    style={{
                                                        underline: styles.textFieldUnerline,
                                                        borderBottomColor:theme.palette.primary.dark,
                                                    }}
                                                />
                                            } */
                                            value={this.getScope(activeCard, "label")}
                                            displayEmpty
                                            onChange={event => this.handleSelectChange(event.target.value)}>
                                            <MenuItem value="" disabled><Trans i18nKey='Scopes.title_dropwon_choose'></Trans></MenuItem>
                                            {this.renderRoomSelectItems()}
                                        </Select>
                                        <FormHelperText><Trans i18nKey='Scopes.helpertext_choose_area_name'></Trans></FormHelperText>
                                    </FormControl>
                                </SidebarItem>
                            )}
                            {(typeof activeCard === "number" && !this.state.openModeSettings)
                            && (
                                <SidebarItem
                                    title={t('Scopes.title_mode')}
                                    subtitle={t('Scopes.subtitle_mode')}
                                    divider={1 !== scopes[activeCard].modeId}
                                >
                                <br/>
                                    
                                    <Mode>
                                        <ModeItem
                                            icon={<ManuelItem/>}
                                            label={t('Scopes.label_modeitem_manual')}
                                            checked={(scopes[activeCard].modeId === 1)}
                                            handleCheckboxChange={() => this.handleModeChange(1)}
                                        />
                                        <ModeItem
                                            icon={<ShockVentilationSrc/>}
                                            label={t('Scopes.label_modeitem_boost')}
                                            checked={(scopes[activeCard].modeId === 2)}
                                            handleCheckboxChange={() => this.handleModeChange(2)}
                                        />
                                        <ModeItem
                                            icon={<SleepTimeIcon/>}
                                            label={t('Scopes.label_modeitem_sleep')}
                                            checked={(scopes[activeCard].modeId === 3)}
                                            handleCheckboxChange={() => this.handleModeChange(3)}
                                        />
                                        <ModeItem
                                            icon={<HumiditySrc/>}
                                            label={t('Scopes.label_modeitem_humi')}
                                            checked={(scopes[activeCard].modeId === 4)}
                                            handleCheckboxChange={() => this.handleModeChange(4)}
                                        />
                                        <ModeItem
                                            style={{whiteSpace: 'noWrap'}}
                                            icon={<TimeProgramSrc/>}
                                            label={t('Scopes.label_modeitem_time')}
                                            checked={(scopes[activeCard].modeId === 5)}
                                            handleCheckboxChange={() => this.handleModeChange(5)}
                                        />
                                        <ModeItem
                                            icon={<CO2Src/>}
                                            label={t('Scopes.label_modeitem_co2')}
                                            checked={(scopes[activeCard].modeId === 6)}
                                            handleCheckboxChange={() => this.handleModeChange(6)}
                                        />
                                    </Mode>
                            
                                    {(2 === scopes[activeCard].modeId || 1 === scopes[activeCard].modeId)
                                    && (
                                        <Slider
                                            color={theme.palette.primary.dark}
                                            label={t('Scopes.label_fanlevel')}
                                            value={(1 === scopes[activeCard].modeId) ? scopes[activeCard].value : 6}
                                            disabled={2 === scopes[activeCard].modeId}
                                            from={0}
                                            to={6}
                                            steps={1}
                                            sx={{width:"100%"}}
                                            handleSliderChange={value => this.handleSliderChange(value)}
                                        />
                                    )}
                                    {(3 === scopes[activeCard].modeId || 4 === scopes[activeCard].modeId || 6 === scopes[activeCard].modeId)
                                    &&
                                    <div style={{ height: 50 }}/>
                                    }

                                    {(5 === scopes[activeCard].modeId)
                                    && (
                                        <SwitchTime>
                                            {this.getSwitchTimeElements()}
                                            {scopes[activeCard].unsavedTimerChanges && this.getSwitchTimeSave()}
                                        </SwitchTime>
                                    )
                                    }
                                </SidebarItem>
                            )}

                            {(2 === scopes[activeCard].modeId && !this.state.openModeSettings)
                            && (
                                <SidebarItem>
                                    <div>
                                        <Information title>
                                            <Trans i18nKey='Scopes.information_mode_boost_01'></Trans>
                                        </Information>
                                        <Information>
                                        <Trans i18nKey='Scopes.information_mode_boost_02'></Trans>
                                        </Information>
                                    </div>
                                </SidebarItem>
                            )}

                            {(3 === scopes[activeCard].modeId && !this.state.openModeSettings)
                            && (
                                <SidebarItem>
                                    <Information title>
                                        <Trans i18nKey='Scopes.information_mode_sleep_01'></Trans>
                                        {this.getSlumberTime()}
                                        <Trans i18nKey='Scopes.information_mode_sleep_02'></Trans>
                                        <br/>
                                        <Trans i18nKey='Scopes.information_mode_sleep_03'></Trans>
                                    </Information>
                                </SidebarItem>
                            )}

                            {(4 === scopes[activeCard].modeId && !this.state.openModeSettings)
                            && (
                                <SidebarItem>
                                    <Information title>
                                    <Trans i18nKey='Scopes.information_mode_humi_01'></Trans>
                                    </Information>
                                    <Information>
                                    <Trans i18nKey='Scopes.information_mode_humi_02'></Trans> {this.getScope(activeCard, "feuchte")} %

                                    </Information>
                                </SidebarItem>
                            )}

                            {(5 === scopes[activeCard].modeId && !this.state.openModeSettings)
                            && (
                                <SidebarItem>
                                    <Information title>
                                    <Trans i18nKey='Scopes.information_mode_time_01'></Trans>
                                    </Information>
                                </SidebarItem>
                            )}

                            {(6 === scopes[activeCard].modeId && !this.state.openModeSettings)
                            && (
                                <SidebarItem>
                                    <Information title>
                                    <Trans i18nKey='Scopes.information_mode_co2_01'></Trans>
                                    </Information>
                                    <Information>
                                    <Trans i18nKey='Scopes.information_mode_co2_02'></Trans>
                                     {this.getScope(activeCard, "co2")} ppm
                                    </Information>
                                </SidebarItem>
                            )}

                            {(this.state.openModeSettings && activeCard)
                            && (
                                <Ax>
                                    <SidebarItem divider>
                                        <TimePicker
                                            value={scopes[activeCard].timers[this.state.openModeSettings].time}
                                            label={t('Scopes.label_timepicker')}
                                            timePickerChange={time => this.timePickerChange(time)}

                                        />
                                    </SidebarItem>
                                    <SidebarItem title={t('Scopes.title_mode')} subtitle={t('Scopes.subtitle_mode')}>
                                        <Mode>
                                            <ModeItem
                                                icon={<ManuelItem/>}
                                                label={t('Scopes.cardtext_label_manual')}
                                                checked={(scopes[activeCard].timers[this.state.openModeSettings].selectedMode === 1)}
                                                handleCheckboxChange={() => this.handleTimerChange(1)}
                                            />
                                            <ModeItem
                                                icon={<ShockVentilationSrc/>}
                                                label={t('Scopes.cardtext_label_boost')}
                                                checked={(scopes[activeCard].timers[this.state.openModeSettings].selectedMode === 2)}
                                                handleCheckboxChange={() => this.handleTimerChange(2)}
                                            />
                                            <ModeItem
                                                icon={<HumiditySrc/>}
                                                label={t('Scopes.cardtext_label_humi')}
                                                checked={(scopes[activeCard].timers[this.state.openModeSettings].selectedMode === 4)}
                                                handleCheckboxChange={() => this.handleTimerChange(4)}
                                            />
                                            <ModeItem
                                                icon={<CO2Src/>}
                                                label={t('Scopes.cardtext_label_co2')}
                                                checked={(scopes[activeCard].timers[this.state.openModeSettings].selectedMode === 6)}
                                                handleCheckboxChange={() => this.handleTimerChange(6)}
                                            />
                                        </Mode>
                                    </SidebarItem>
                                    {(2 >= scopes[activeCard].timers[this.state.openModeSettings].selectedMode)
                                    && (
                                        <SidebarItem>
                                            <Slider
                                                label={t('Scopes.label_fanlevel')}
                                                value={(1 === scopes[activeCard].timers[this.state.openModeSettings].selectedMode) ? scopes[activeCard].timers[this.state.openModeSettings].ventilationLevel : 6}
                                                disabled={2 === scopes[activeCard].timers[this.state.openModeSettings].selectedMode}
                                                from={0}
                                                to={6}
                                                steps={1}
                                                handleSliderChange={value => this.handleSliderChangeTimers(this.state.openModeSettings, value)}
                                            />
                                        </SidebarItem>
                                    )}
                                </Ax>
                            )}
                        </div>
                    )}
                </Sidebar>
            </div>
        )
    }
}

//Scopes = withStyles(styles)(Scopes)

export default Scopes;
